import { render } from "./DialogStoricoContenuto.vue?vue&type=template&id=2ecca62c"
import script from "./DialogStoricoContenuto.vue?vue&type=script&lang=js"
export * from "./DialogStoricoContenuto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__